<template>
  <div id="canvas" v-if="loggedIn" class="gift-choice-page" :class="isBundle ? 'bundle' : ''">
    <div id="mContainer" class="main-container no-scrollbar">
      <video v-if="videoHeaders[0]" class="custom-header desktop" :class="(isOneRedeem || isSingleTab1Gift) ? 'no-tabs' : ''" autoplay="autoplay" playsinline="" muted="" loop="loop" alt="gif" :src="videoHeaders[0]"></video>
      <img v-else-if="collectionImage" :src="collectionImage.src" class="custom-header desktop" :class="(isOneRedeem || isSingleTab1Gift) ? 'no-tabs' : ''" width="1920px"/>
      <video v-if="videoHeaders[1]" class="custom-header mobile" autoplay="autoplay" :class="(isOneRedeem || isSingleTab1Gift) ? 'no-tabs' : ''" playsinline="" muted="" loop="loop" alt="gif" :src="videoHeaders[1]"></video>
      <img v-else-if="collectionImage" :src="collectionImage.alt" class="custom-header mobile" :class="(isOneRedeem || isSingleTab1Gift) ? 'no-tabs' : ''" width="1920px"/>
      <p v-if="!collectionImage" class="main-title">{{headerTitle}}</p>
      <p v-if="!collectionImage && !isOneRedeem" class="main-subtitle">You can pick one or many gifts to hit the value your sender has selected. Go ahead, have fun.</p>
      <div v-if="!isOneRedeem && !isSingleTab1Gift" id="tabs" class="tabs" :class="[isSticking ? 'sticky' : '',showTicker ? 'hasTicker' : '']">
        <div class="tab" :class="[(selectedTab == tab.value || (!selectedTab && i == 0)) ? 'selected' : '',(isBundle && tab.value > 0 && tabs[tab.value - 1].currentQty > 0) ? 'disabled' : '',(!isBundle && tab.currentQty == 0) ? 'disabled' : '']" v-for="(tab,i) in tabs">
          <div @click="selectTab(tab.value)" class="happybox-button white">
            <span v-if="isBundle">Step {{ i+1 }}:&nbsp;</span>
            <span v-if="tab.maxQty == 1">Pick {{ tab.currentQty }}{{ tab.leftOver > 0 ? '+ Gift(s)' : ' Gift' }}</span>
            <span v-else-if="tab.maxQty > 1">Pick up to {{ tab.currentQty }} Gifts</span>
          </div>
        </div>
      </div>
      <div class="ticker" v-if="tickerText && tickerText != ''" :style="tickerColor ? 'background-color:' + tickerColor : ''">
        <p>{{ tickerText }}</p>
      </div>
      <div class="products-listing">
        <p class="capacity-overlay" v-if="maxProductsToAdd == 0">100% full! Proceed to the next step <br class="mobile"/> or remove items to keep shopping.</p>
        <p class="bundle-instructions" v-html="bundleInstructions" v-if="bundleInstructions && maxProductsToAdd != 0"></p>
        <p class="purple-copy" v-if="isHBHoliday && isOneRedeem">Redeem your holiday gift below!</p>
        <p class="tier-subcopy" v-if="!isHBHoliday && !isBundle" v-html="tabCopy"></p>
        <div class="products-inner-container" :class="maxProductsToAdd == 0 ? 'disabled' : ''">
          <div v-for="product in filteredProducts" :key="product.id" class="product-container" :class="[cartProducts.find(x => x.id == product.id) ? 'selected' : '',isOneRedeem ? 'big':'']">
            <img @click="removeProduct(product)" class="circle remove"  src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x">
            <div @click="selectProduct(product)" class="product-image-container" >
              <span v-if="mainBadge(product) != null" class="main-badge">{{ mainBadge(product) }}</span>
              <img class="info" src="https://cdn.shopify.com/s/files/1/1363/8433/files/info.svg?v=1734017876"/>
              <div class="loading">
                <img class="lazyload main-image" width="150" height="150" :src="product | getProductImage"/>
              </div>
              <img v-if="product.images.length > 1 && !isNoHover(product)" :src="product.images[1].src" class="hover-image" />
            </div>
            <p class="product-title">{{ product.title }}</p>
            <button v-if="isOneRedeem" @click="selectProduct(product)" class="happybox-button green border">Redeem</button>
          </div>
        </div>
      </div>
    </div>
    <SideCart 
      :capacity="percentageFilledCapacity" 
      :selectedProducts="cartProducts" 
      :maxProductsToAdd="maxProductsToAdd"
      :isLoading="isLoading"
      :isBundle="isBundle"
      :tabs="tabs"
      :redeem_without_full_capacity="redeem_without_full_capacity"
      @removeproduct="removeProduct($event)"
      @checkout="goCheckout"
      @openmodal="openModal($event)"
    />
    <ProductModal 
      v-if="selectedProduct" 
      :collectionValue="collectionValue"
      :availableCapacity="availableCapacity"
      :product="selectedProduct" 
      :cartProducts="cartProducts"
      :isLoading="isLoading"
      :isBundle="isBundle"
      :tabs="tabs"
      :isOneRedeem="isOneRedeem"
      :collectionHandle="collectionHandle"
      @closemodal="closeModal"
      @changevariant="changeVariant"
      @selectproduct="addProduct($event)" 
      @cleanadd="cleanAdd($event)"
      @checkout="goCheckout"
      @nextstep="nextStep()"
    />
  </div>
  <div v-else class="spinner-container" :class="reclaimed ? 'top' : ''">
    <p v-if="invalidToken">Invalid Access</p>
    <div class="reclaimed-container" v-else-if="reclaimed">
      <p class="title">
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"/>
        <span>Great Choice</span>
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"/>
      </p>
      <p class="subtitle">You'll receive updates and tracking info via email!</p>
    </div>
    <div v-else class="loading-container">
      <p>
        If you are having trouble loading this page, please turn off your VPN or company wifi. <br class="desktop"/> Due to IT security restrictions, you may need to open the link on a personal device or forward the email to a personal email address to redeem your gift.<br class="desktop"/>
        If you are still having issues, please reach out to <a href="mailto:orders@happyboxstore.com">orders@happyboxstore.com</a> for immediate assistance.
      </p>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import confetti from "canvas-confetti";
import axios from "axios";
import ProductModal from "./components/ProductModal.vue";
import SideCart from "./components/SideCart.vue";
import Vue from "vue";
import Swal from 'sweetalert2/dist/sweetalert2.js'
export default {
    data(){
        return {
            products: [],
            bundles: [],
            isBundle: false,
            selectedProduct: null,
            cartProducts: [],
            loggedIn: false,
            apiUrl: "https://portal.happyboxstore.com:5054",
            giftToken: null,
            invalidToken: null,
            isLoading: false,
            reclaimed: false,
            collectionImage: null,
            corporate: null,
            steps: ["PICK YOUR GIFT","ADD YOUR ADDRESS"],
            extraProperties: [],
            selectedTab: null,
            collectionCapacity: 0,
            isSticking: false,
            showTicker:false,
            collectionHandle: null,
            x:0,
            y:0,
            videoHeaders: [],
            confirmed: false,
            fixed_address: null,
            individualChoice: false,
            tickerText: "",
            tickerColor: null,
            redeem_without_full_capacity: false,
            header_title: "",
            header_subtitle: "",
            productSent: "",
        }
    },
    components: {
      SideCart,
      ProductModal
    },
    computed:{
      tabs(){
        if(this.isBundle){
          let values = this.bundles.map((x,i) =>{return {maxQty: x.qty,value:i,currentQty:x.qty - this.bundleAvailableCapacity[i] }})
          values.sort((a,b) => a.value - b.value);
          return values;
        }
        else if(this.products && this.products.length > 0 && this.collectionValue){
          let values = this.products.map((x) => {
            let value = 0
            let tags = x.tags.split(", ");
            let valueTag = tags.find(y => y.toLowerCase().includes("goc_capacity_"))
            if(valueTag){
              valueTag = valueTag.split("_")[2];

              value = parseInt(valueTag);
            }
            let customValue = tags.find(y => y.toLowerCase().includes(`custom_capacity_${this.collectionHandle}`));
            if(customValue){
              customValue = customValue.split("_")[3];

              value = parseInt(customValue);
            }

            return value;
          })
          
          values = [...new Set(values.filter(x => x > 0))].map(x => {return {maxQty: Math.floor(this.collectionValue / x),value:x,currentQty:Math.floor(this.availableCapacity / x),leftOver:this.collectionValue % x}});
          values.sort((a,b) => b.value - a.value);
          return values;
        }

        return [];
      },
      headerTitle(){
        if(this.header_title && this.header_title != ""){
          return this.header_title;
        }
        else{
          return `Time to ${this.isOneRedeem ? 'Claim' : 'Pick'} Your Gift!`
        }
      },
      collectionValue(){
        return this.collectionCapacity;
      },
      filteredProducts(){
        if(this.tabs){
          let currentTab = this.selectedTab ? this.selectedTab : this.tabs[0].value;
          let products = [];
          if(this.isBundle){
            products = this.bundles[currentTab].products;
          }
          else{
            products = this.products.filter((x) => {
              let tags = x.tags.split(", ");
              let customValue = tags.find(y => y.toLowerCase().includes(`custom_capacity_${this.collectionHandle}`));
              if(customValue){
                return tags.some(tag => tag.toLowerCase() == `custom_capacity_${this.collectionHandle}_${currentTab}`);
              }
              return tags.some(tag => tag == `GOC_Capacity_${currentTab}`);
            });
          }
          let tab = this.tabs.find(x => x.value == currentTab);
          if(this.tabs.length > 1 || (this.tabs.length == 1 && tab.maxQty > 1) || this.isBundle){
            products = products.filter(x => !x.tags.includes("Dropship"));
          }

          return products
        }

        return [];
      },
      filledCapacity(){
        if(this.cartProducts && this.cartProducts.length > 0 && this.collectionValue){
          let values = this.cartProducts.map((x) => {
            let value = 0
            let tags = x.tags.split(", ");
            let valueTag = tags.find(y => y.toLowerCase().includes("goc_capacity_"))
            if(valueTag){
              valueTag = valueTag.split("_")[2];

              value = parseInt(valueTag) * x.qty;
            }
            let customValue = tags.find(y => y.toLowerCase().includes(`custom_capacity_${this.collectionHandle}`));
            if(customValue){
              customValue = customValue.split("_")[3];

              value = parseInt(customValue) * x.qty;
            }

            return value;
          })
          return values.reduce((partialSum,a) => partialSum + a,0);
        }
        return 0;
      },
      percentageFilledCapacity(){
        if(this.isBundle){
          return  Math.round((this.bundleAvailableCapacity.reduce((prev,number) => prev + number,0) * 100) / this.tabs.reduce((prev,tab) => prev + tab.maxQty,0));
        }
        else
          return Math.round((this.filledCapacity * 100) / this.collectionValue);
      },
      bundleAvailableCapacity(){
        if(this.isBundle){
          return this.bundles.map((x,i) =>{
            let products = this.cartProducts.filter(x => x.tab == i);
            return products.reduce((prev,product) => prev + product.qty,0);
          })
        }
      },
      availableCapacity(){
        return this.collectionValue - this.filledCapacity;
      },
      maxProductsToAdd(){
        if(this.tabs && this.tabs.length > 0){
          if(this.isBundle){
            return this.tabs.reduce((sum,x) => sum + x.currentQty,0);
          }
          else{
            let tabValues = this.tabs.map(x => x.value);
            return Math.floor( (this.availableCapacity) / Math.min(...tabValues));
          }
        }

        return 0
      },
      dataToAdd(){
        if(this.cartProducts && this.cartProducts.length > 0){
          let baseProperties = {};
          if(this.corporate){
            baseProperties.Corporate = true;
            baseProperties.CorporateName = this.corporate;
            baseProperties._corpGift = this.giftToken;
          }
          else {
            baseProperties._gift = this.giftToken;
          }
          baseProperties._redeem = true;
          baseProperties._collectionRedeemed = this.productSent;
          return this.cartProducts.map((product) =>{
            let data = {
              id: product.variants[0].id,
              quantity: product.qty,
              properties: Object.assign(product.properties || {}, baseProperties)
            };
            let tags = product.tags.split(",");
            if(this.corporate)
              if(tags.find(x => x.includes("Value_"))){
                let valueTag = tags.find(x => x.includes("Value_"));
                data.properties._value = valueTag.split("_")[1];
              }
              else
                data.properties._value = this.findItemPrice(product);
            
            if(tags.find(x => x.includes("Dropship_"))){
              let dropshipTag = tags.find(x => x.includes("Dropship_"));
              let dropshipIdTag = tags.find(x => x.includes("DropshipId_"));
              data.properties._Dropship = dropshipTag.split("_")[1];
              data.properties._DropshipId = dropshipIdTag.split("_")[1];
            }
            if(this.extraProperties && this.extraProperties.length > 0){
              let productExtras = this.extraProperties.filter(x => x.id == product.id);
              for(let property of productExtras){
                data.properties[property.name] = property.value;
              }
            }
            return data;
          })
        }
        return [];
      },
      bundleInstructions(){
        if (this.isBundle){
          if(this.tabs[0].currentQty != 0){
            return "<p>It's time to pick your gift! You'll be prompted to pick out 2 total gifts.</p> <p><strong>Select your first gift:</strong></p>";
          }
          else {
            if(this.collectionHandle == "waste-connections-holiday")
              return `<p>Add on the below gift option if you like! Otherwise, please press "Skip."</p>`
            else
            return `<p>It's time to pick your gift! You'll be prompted to pick out 2 total gifts.</p><p><strong>Great choice! Select your second gift.</strong></p>`;
          }
        }

        return null;
      },
      isOneRedeem(){
        return (this.tabs.length == 1 && this.filteredProducts.length == 1);
      },
      isSingleTab1Gift(){
        return (this.tabs.length == 1 && this.tabs[0].maxQty == 1)
      },
      isHBHoliday(){
        return this.collectionHandle.includes("client-eoy-2024-gift-");
      },
      tabCopy(){
        if(this.header_subtitle && this.header_subtitle != ""){
          return this.header_subtitle;
        }
        const currentTabValue = this.selectedTab ? this.selectedTab : this.tabs[0].value;
        const currentTab = this.tabs.find(x => x.value == currentTabValue);
        if(currentTab){
          if(currentTab.maxQty == 1){
            if(currentTab.leftOver == 0){
              return "You're able to select <strong>one</strong> gift from the below.";
            }
            else
              return "You're able to select <strong>one</strong> gift from the below, and one from another available collection."
          }
          else if(currentTab.maxQty > 1){
            return "Mix and match gifts from the below & other available collections to your liking!"
          }
        }

        return "";
      },
    },
    methods:{
      selectProduct(product){
        this.selectedProduct = product;
        if(this.isOneRedeem && product.variants.length == 1){
          let productToSend = JSON.parse(JSON.stringify(product));
          productToSend.qty = 1;
          this.addProduct(productToSend);
        }
      },
      findItemPrice(item){
        let price = null;
        const tags = item.tags.split(",");
        const corporateTag = tags.find(tag => tag.startsWith(`${this.corporate}_Price_`));
        if (corporateTag) {
            // Priority 1: Corporate price tag
            price = parseFloat(corporateTag.split('_').pop());
        } else {
            const historyTags = tags
            .filter(tag => tag.startsWith("PriceHistory_"))
            .map(tag => {
              const [_, indexStr, ...entries] = tag.split('_');
              const index = parseInt(indexStr);
              return { index, entries };
            })
            .sort((a, b) => a.index - b.index); // sort by chunk index
        
            const allEntries = [];
            
            for (const tag of historyTags) {
                for (const entry of tag.entries) {
                const [label, priceStr] = entry.split(':');
                allEntries.push({
                    date: label === 'INIT' ? '00000000' : label,
                    price: parseFloat(priceStr),
                });
                }
            }
        
            if (allEntries.length > 0) {
                // Sort by date
                const sorted = allEntries.sort((a, b) => a.date.localeCompare(b.date));
            
                let today = new Date();
                const rangeStart = today.replace(/-/g, '');
            
                // Find last price before or at the range start
                const matching = sorted.filter(entry => entry.date <= rangeStart);
                if (matching.length > 0) {
                  price = matching[matching.length - 1].price;
                }
            }

            // Priority 3: fallback Price_ tag
            if (price === null) {
                const fallbackTag = tags.find(tag => tag.startsWith('Price_'));
                const fallbackTag2 = tags.find(tag => tag.startsWith('GOC_Capacity_'));
                if (fallbackTag) {
                    price = parseFloat(fallbackTag.split('_').pop());
                }
                else if(fallbackTag2){
                    price = parseFloat(fallbackTag2.split('_').pop());
                }
            }
        }

        return price;
      },
      closeModal(){
        this.selectedProduct = null;
      },
      addProduct(event){
        let variantId = event.variants[0].id;
        let i = this.cartProducts.findIndex(x => x.variants.find(y => y.id == variantId));
        if(i < 0){
          confetti({origin:{
            x: this.x
            ,y: this.y
          },zIndex: 9000});
          this.cartProducts.push(event);
        }
        else {
          Vue.set(this.cartProducts[i],"qty",event.qty)
        }
      },
      cleanAdd(event){
        if(this.isBundle){
          this.cartProducts = this.cartProducts.filter(x => x.tab != event.tab);
        }
        else
          this.cartProducts = [];
        this.addProduct(event);
      },
      removeProduct(product){
        let variantId = product.variants[0].id;
        let i = this.cartProducts.findIndex(x => x.variants.find(y => y.id == variantId));
        if(i > -1){
          this.cartProducts.splice(i,1);
        }
        else{
          let productId = product.id;
          let i2 = this.cartProducts.findIndex(x => x.id == productId);
          if(i2 > -1){
            this.cartProducts.splice(i2,1);
          }
        }
      },
      mainBadge(product){
        let splitTags = product.tags.split(", ");
          var tags =  splitTags.filter(y => y.includes("Tag_"));
          if(tags.length > 0){
            tags = tags.map((x) => {
              var currentTag = x.replace("Tag_","").replace("Tag_","");
              return currentTag;
            })

            return tags[0];
          }

          var ethos = splitTags.filter(y => y.includes("Filter_Ethos"));
          if(ethos.length > 0){
            ethos = ethos.map((x) => {
              var currentEthos = x.replace("Filter_","").split("_")
              return currentEthos[1]
            })

            return ethos[0];
          }

          return null
          
        },
        changeVariant(event){
          if(this.extraProperties.length > 0){
            let index = this.extraProperties.findIndex(x => x.name == event.name);
            if(index > -1){
              this.extraProperties[index].value = event.value;
              return
            }
          }
          this.extraProperties.push(event);
        },
        openModal(product){
          let selected = this.products.find(x => x.id == product.id);
          if(selected){
            this.selectedProduct = selected;
          }
        },
        async login(){
          this.giftToken = localStorage.getItem("giftToken");
          if(!this.giftToken){
            this.invalidToken = true;
            return;
          }
          let response = await axios.post(`${this.apiUrl}/giving/giftLogin`,{token: this.giftToken})
          if(response.data){
            response = response.data;
            if(response.error){
              this.invalidToken = true;
              return;
            }
            else if(response.reclaimed){
              this.reclaimed = true;
            }
            else if(response.cancelled){
              this.invalidToken = true;
            }
            else{
              this.collectionHandle = response.handle;
              let metafields = await axios.get(`/collections/${response.handle}?view=metafields`);
              if(metafields.data && metafields.data.metafields){
                metafields = metafields.data.metafields;
                if(metafields.value && metafields.value > 0){
                  this.collectionCapacity = metafields.value;
                  this.individualChoice = false;
                }
                else
                  this.collectionCapacity = 1;
                if(metafields.video_headers && metafields.video_headers.length > 0){
                  this.videoHeaders = metafields.video_headers;
                }
                if(metafields.fixed_address && metafields.fixed_address.address1 && metafields.fixed_address.address1 != ""){
                  this.fixed_address = metafields.fixed_address;
                }
                if(metafields.ticker && metafields.ticker != ""){
                  this.tickerText = metafields.ticker;
                }
                if(metafields.ticker_color && metafields.ticker_color != ""){
                  this.tickerColor = metafields.ticker_color;
                }
                if(metafields.redeem_without_full_capacity){
                  this.redeem_without_full_capacity = metafields.redeem_without_full_capacity;
                }
                if(metafields.header_subtitle && metafields.header_subtitle != ""){
                  this.header_subtitle = metafields.header_subtitle;
                }
                if(metafields.header_title && metafields.header_title != ""){
                  this.header_title = metafields.header_title;
                }
              }
              if(response.bundles && response.bundles.length > 0){
                this.isBundle = true;
                this.bundles = response.bundles;
                this.products = response.bundles.flatMap((x,i) =>{
                  return x.products.map((y) => {
                    y.variants = y.variants.filter(z => z.price == "0.00").map((z) => {
                      if(z.inventory_policy == "continue"){
                        z.inventory_quantity = 999;
                      }
                      return z
                    })

                    y.tab = i;
                    return y;
                  })
                })
              }
              else {
                this.products = response.products.map((x) => {
                  x.variants = x.variants.filter(y => y.price == "0.00").map((y) => {
                    if(y.inventory_policy == "continue"){
                      y.inventory_quantity = 999;
                    }

                    return y
                  })
                  if(this.individualChoice){
                    let tags = x.tags ? x.tags.split(", ") : [];
                    let hasCapacityTag = false;

                    tags = tags.map(tag => {
                      if (tag.startsWith("GOC_Capacity_")) {
                        hasCapacityTag = true;
                        return "GOC_Capacity_1";
                      }
                      return tag;
                    });

                    if (!hasCapacityTag) {
                      tags.push("GOC_Capacity_1");
                    }
                    x.tags = tags.join(", ");
                  }

                  return x;
                })
              }
              this.corporate = response.corporate;
              this.loggedIn = true;
              this.collectionImage = response.collection_image;
              this.productSent = response.productSent

              await this.$nextTick(() => {});
              let canvas = document.getElementById('canvas');
              if(window.matchMedia("(pointer: coarse)").matches) {
                canvas.addEventListener('touchend', this.onTouchEnd, false);
              }
              else{
                canvas.addEventListener('mousemove', this.onMouseMove, false);
              }
              var that = this;
              var element = document.getElementById("tabs");
              if(element){
                var observer = new IntersectionObserver(function(entries) {
                  if(entries[0].intersectionRatio < 1){
                    that.isSticking = true;
                  }
                  else{
                    that.isSticking = false;
                  }
              }, { threshold: [0,1] });

              observer.observe(element);
              }
            }
          }
        },
        onMouseMove(e){
          this.x = e.clientX / window.innerWidth;
          this.y = e.clientY / window.innerHeight;
        },
        onTouchEnd(e){
          if(e.changedTouches.length > 0){
            this.x = e.changedTouches[0].clientX / window.innerWidth;
            this.y = e.changedTouches[0].clientY / window.innerHeight;
          }
        },
        selectTab(value){
          if(this.isBundle){
            let tab = this.tabs.find(x => x.value == value);
            if(tab.currentQty == 0 || tab.value == 0 || this.tabs[value - 1].currentQty == 0)
              this.selectedTab = value;
          }
          else
            this.selectedTab = value;
          document.getElementById('mContainer')?.scrollTo({ top: 0, behavior: 'auto' });
        },
        async goCheckout(){
          if((this.maxProductsToAdd != 0 && this.redeem_without_full_capacity != true) || this.isLoading)
            return;
          if(this.corporate == "Capital One" && this.confirmed == false){
            this.fireSwalAlert();
            return
          }
          this.isLoading = true;
          await this.validateToken();
          await this.clearCart();
        },
        async fireSwalAlert(){
          Swal.fire({
            title: 'Confirm Final Gift Selection',
            html: `<p>Once you click "submit", you'll be prompted to complete your gift redemption <br/> experience, and you will not be able to adjust your gift selection.</p>`,
            showCancelButton: true,
            confirmButtonText: "Submit Gift Selection",
            cancelButtonText: "Adjust Gift Selection",
            reverseButtons: true,
            customClass:{
                container:"swal-custom-container",
                popup: "swal-custom-popup-2 rounded",
                title:"swal-title",
                confirmButton: "happybox-button green border",
                cancelButton: "happybox-button white border",
            },
            buttonsStyling: false,
            }).then((result) => {
            if (result.isConfirmed) {
              this.confirmed = true;
              this.goCheckout();
            } else if ( result.dismiss === Swal.DismissReason.cancel )
            {
            }
            else{
            }
          })
        },
        async validateToken(){
          let response = await axios.post(`${this.apiUrl}/giving/giftLogin`,{token: this.giftToken})
          if(response.data){
            response = response.data
            if(response.error || response.cancelled || response.reclaimed){
              location.reload();
            }
          }
          else {
            location.reload();
          }
        },
        async clearCart(){
          await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
          }).then(response => {
            if(this.fixed_address)
              this.specialCheckout();
            else
              this.addToCart();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        },
        async specialCheckout(){
          let response = await axios.post(`${this.apiUrl}/giving/specialCheckout`,{address: this.fixed_address,'items':this.dataToAdd},{
            headers: {
              'Content-Type': 'application/json',
              'Authorization': this.giftToken,
            },
            timeout: 50000
          })
          localStorage.setItem('_gs-redirect',true);
          localStorage.setItem('gift', true);
          localStorage.removeItem("giftToken");
          location.href = response.data.draftOrder.invoiceUrl;
        },
        async addToCart(){
          try{
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items: this.dataToAdd })
            });

            if(this.productSent == "Move More $50 Collection" || this.productSent == "Move More $75 Collection"){
              const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({  discount: 'QUALIOMOVEMORE' })
              });
            }

            localStorage.setItem('_gs-redirect', true);
            localStorage.setItem('gift', true);
            localStorage.removeItem('giftToken');
            window.location.href = '/checkout';
          }
          catch(ex){
            console.error('Error:', ex);
          }
        },
        nextStep(){
          this.selectTab(this.selectedTab + 1);
        },
        isNoHover(product){
          return product.tags.includes("no_hover")
        }
    },
    mounted(){
      let canvas = document.getElementById('IndividualChoice');
      if(canvas){
        this.individualChoice = true;
      }
      this.login();
    },
}
</script>

<style>
    #attentive_overlay{
      display: none;
    }

    .gift-choice-page p,.gift-choice-page span{
      color: #0F0C38;
      margin: 0;
    }

    .mothers-day-ticker{
      display: none;
    }
    </style>



    <style scoped>
    .wiggle{
        width: 100%;
        overflow: hidden;
        position: relative;
    }

    .wiggle img{
        width: 120%;
        height: 100%;
        position: relative;
        left: -10%;
    }

    .gift-choice-page{
      width: 100%;
      display: flex;
      overflow: hidden;
      height: 100%;
    }

    .gift-choice-page .header.custom img{
      padding: unset;
      width: 100%;
    }

    .gift-choice-page .header{
      background-color: #f2f6ff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .gift-choice-page .header img{
      width: 23%;
      padding: 2% 0%;
    }

  .wiggle.white{
		background: linear-gradient(0deg, white 40%, #eee6ff 60%);
	}

  .happybox-button.orange{
    padding: 1% 10%;
    font-size: 1.5vw;
    border: 1px solid #d9bd47;
  }

  .gift-choice-page .main-container{
    text-align: center;
    width: 100%;
    min-width: 90%;
    height: 100%;
    overflow: auto;
    scroll-behavior: smooth;
    background-color: #f8f9fd;
    display: flex;
    flex-direction: column;
  }

  .gift-choice-page .main-container .main-title{
    margin-top: 1%;
    font-size: 4vw;
    font-weight: 500;
    font-family: moret, sans-serif;
  }

  .gift-choice-page .main-container .main-subtitle{
    font-size: 1.15vw;
    margin-bottom: 1em;
  }

  .next-step{
    font-size: 1.8vw;
    margin: 2% 0%;
  }

  .next-step span,.next-step strong{
    font-style: italic;
    font-family: moret,sans-serif;
  }

  .main-legend{
    text-align: left;
    font-size: 1.6vw;
    padding-bottom: 5%;
  }

  .products-listing{
    width: 100%;
    padding: 2% 10% 2% 5%;
    min-height: 40vh;
    background-color: #f8f9fd;
    box-shadow: 0px -1px 0px 1px #0000001f;
    position: relative;
  }

  .product-container {
    width: 23%;
    background-color: white;
    box-shadow: 0 0 2px #0000004d;
    border-radius: 8px;
    padding: 1%;
    position: relative;
  }

  .product-container.big{
    width: 40%;
  }

  .product-container.big .product-title{
    font-size: 2vw;
  }

  .product-container .loading {
    width: 100%;
    height: auto;
    cursor: pointer;
    position: relative;
  }
  .product-container .loading .main-image{
    z-index: 2;
    background-color: #f6f6f6;
    height: 100%;
    width: 100%;
    position: relative;
    aspect-ratio: 1;
    display: block;
    object-fit: cover;
  }

  .product-container .loading:before {
    content: "";
    position: absolute;
    z-index: 1;
    top: 0%;
    left: 0%;
    width: 100%;
    padding-bottom: 100%;
    animation: skeleton-loading 1s linear infinite alternate;
  }

  .product-container .hover-image {
    background-color: #f6f6f6;
    width: 100%;
    height: 100%;
    object-fit: contain;
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 2;
    -webkit-transition: all .35s ease-in-out;
    transition: all .35s ease-in-out;
    opacity: 0;
  }

  .product-image-container:hover .hover-image {
    opacity: 1;
  }

  .product-container .product-title{
    font-size: 1vw;
    margin: 5% 0%;
    font-weight: bold;
    line-height: 1.2;
    text-align: center
  }

  .product-image-container{
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
  }

  .product-container.selected{
    border: 2px solid #a01adb;
  }

  .hover-container {
    display: flex;
    position: absolute;
    width: 100%;
    bottom: -30%;
    margin: unset;
    -webkit-transition: all .35s ease-in-out;
    transition: all .35s ease-in-out;
    background-color: rgba(225,231,253,0.8);
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    z-index: 2;
  }

  .hover-container img{
    width: 10%;
  }

  .hover-container p{
    color: #5A6BA3;
    font-size: 1vw;
    padding: 2% 0%;
    font-weight: bold;
    letter-spacing: 0.2px;
  }

  .product-image-container:hover .hover-container{
    bottom: 0%;
  }

  .product-container .white{
    border: 1px solid #CFCED8 !important;
  }

  .product-container .happybox-button.green{
    padding: 2%;
    width: 80%;
    font-size: 1.15vw;
    margin-bottom: 5%;
  }

  .continue-container button{
    border: 1px solid #CFCED8;
    padding: 1% 10%;
  }

  .happybox-button.white,.happybox-button.purple,.happybox-button.yellow,.happybox-button.green{
    font-size: 1vw;
    padding: 1% 15%;
  }

  .happybox-button.purple:hover{
    background-color: #e6d7fa;
  }

  .slick-slider{
    width: 100%;
  }

  .slick-track {
  display: flex!important;
}

.slick-slide {
  height: inherit!important;
  display: flex!important;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.slick-slide div{
  width: 100%;
}

.slick-slider {
  margin-bottom: 15px;
}

.slick-arrow:before {
  content: ""!important;
}

  .loading-container{
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .loading-container p{
    font-size: 1.15vw;
    color: #0f0c38;
    font-family: "Karla";
    margin-bottom: 2%;
    text-align: center;
  }

  .spinner-container{
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
  }

  .spinner-container.top{
    align-items: flex-start;
    padding-top: 5%;
  }

  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.3);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #09f;
    animation: spin 1s ease infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  .reclaimed-container{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .reclaimed-container .title{
    font-size: 6vw;
    font-family: moret;
    font-weight: bold;
    display: flex;
    gap: 30px;
    width: 100%;
    justify-content: center;
  }

  .reclaimed-container .title img{
    width: 3%;
  }

  .reclaimed-container .subtitle{
    font-size: 3vw;
    font-family: 'moret';
    font-weight: 300;
    width: 35%;
    text-align: center;
    line-height: 1.2;
  }

  .gifting-header{
    display: flex;
    align-items: center;
    padding: 2%;
    position: relative;
  }

  .tabs{
    width: 100%;
    display: flex;
    padding: 0% 10%;
    justify-content: center;
    position: sticky;
    top: -1px;
    z-index: 4;
  }

  .tabs.sticky{
    padding-top: 1px;
  }

  .tabs .tab{
    width: 30%;
    padding: 2%;
    z-index: 1;
  }

  .tabs .tab.disabled{
    opacity: 0.8;
  }

  .tabs .tab.disabled.selected{
    opacity: 1;
  }

  .tabs .selected{
    background-color: #f8f9fd;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    box-shadow: 0px -1px 0px 1px #0000001f;
  }

  .tabs .tab .happybox-button{
    width: 100%;
    position: relative;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tabs .selected .happybox-button{
    font-weight: 700;
  }

  .tabs .tab .arrow.down{
    display: none;
  }

  .tabs .tab .subtitle{
    font-size: 0.8vw;
    position: absolute;
    top: 25.5%;
    right: 5%;
  }

  .tabs .tab.selected .subtitle{
    display: none;
  }

  .tabs .tab.selected .arrow.down{
    display: inline-block;
    right: 10%;
    top: 40%;
    position: absolute;
  }

  .products-inner-container{
    width: 100%;
    padding: 5% 0;
    background-color: white;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 30px 2%;
    background-color: #f8f9fd;
  }

  .selected .circle.remove{
    display: flex;
  }

  .circle.remove{
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    font-size: 2vw;
    width: 1.5vw;
    height: 1.5vw;
    border-radius: 50%;
    background-color: white;
    color: #0f0c38;
    top: -0.75vw;
    right: -0.75vw;
    padding: unset !important;
    z-index: 3;
    line-height: 1;
  }

  .circle.remove span{
    margin-bottom: 10%;
  }

  .arrow {
    border: solid black;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 2px;
    height: 0px;
    transition: all 0.5s;
    cursor: pointer;
}

.arrow.up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
}

.arrow.down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}

.main-badge{
  background-color: white;
  position: absolute;
  top: 2%;
  left: 2%;
  border: 1px solid #F3EEFA;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 1% 3%;
  font-size: 1.1vw;
  font-weight: bold;
  color: #5981d9;
}

.capacity-overlay{
  color: #5a3089;
  font-size: 1.3vw;
  font-weight: bold;
}

.bundle-instructions,.tier-subcopy{
  font-size: 1.3vw;
}

.disabled{
  opacity: 0.6;
}

.custom-header{
  width: 100%;
  margin-bottom: -6%;
}

.custom-header.no-tabs{
  margin: unset;
}

@media only screen and (min-width: 768px){
  .tabs.sticky{
    padding-top: 1px;
    background-color: white;
  }

  .tabs.sticky.hasTicker{
    padding-top: 51px;
  }
  
  .tabs.sticky .selected{
    background-color: unset;
    box-shadow: unset;
  }

  .tabs.sticky .selected .happybox-button{
    background-color: #E0E5F3;
  }

  .product-image-container .info{
    width: 15%;
    position: absolute;
    right: 2%;
    top: 2%;
    z-index: 3;
    cursor: pointer;
    max-width: 30px;
  }
}

.ticker{
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffd9a1;
  font-weight: bold;
  line-height: 1.2;
}

.purple-copy{
  color: #1C1856;
  font-size: 1.5vw;
}

  @media only screen and (max-device-width: 767px){

    .wiggle img{
      width: 100%;
      left: unset;
    }
    
    .gift-choice-page .header .title{
      font-size: 8vw;
    }

    .gift-choice-page .main-container .main-title{
      font-size: 8vw;
    }

    .gift-choice-page .main-container .main-subtitle{
      font-size: 3.5vw;
      padding: 0% 10%;
      font-weight: 500;
    }

    .product-container {
      width: 47%;
      margin-bottom: 5%;
    }

    .happybox-button.orange{
      font-size: 3.5vw;
      width: 100%;
      margin-top: 5%;
    }

    .happybox-button.white, .happybox-button.purple,.happybox-button.yellow,.happybox-button.green{
      font-size: 3.5vw;
    }

    .next-step{
      font-size: 5vw;
      margin: 5% 0%;
    }

    .continue-container{
        width: 100%;
        background-color: white;
        display: flex;
    }

    .continue-container.sticky{
      position: fixed;
      bottom: 0%;
      left: 0;
      padding: 5%;
      border-top: 1px solid black;
      align-items: center;
      justify-content: center;
    }

    .continue-container button{
      font-size: 3.5vw;
      width: 100%;
      padding: 2% !important;
      border: unset !important;
    }

    .gifting-header{
      justify-content: center;
    }

    .header-step{
      width: 50%;
    }

    .header-step .title{
      font-size: 3vw;
    }

    .header-step .circle{
      width: 4vw;
      height: 4vw;
    }

    .header-line{
      bottom: 33%;
    }

    .hover-container{
      display: none;
    }

    .product-container .happybox-button.green{
      font-size: 3.5vw;
    }

    .product-container .product-title{
      font-size: 3vw;
    }

    .products-listing{
      padding: 5%;
      gap: unset;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      margin-top: 0.5%
    }

    .gift-choice-page .header img{
      width: 70%;
    }

    .product-image-container .info{
      width: 10%;
      position: absolute;
      right: 2%;
      top: 2%;
      z-index: 3;
      cursor: pointer;
    }

    .loading-container p{
      font-size: 3vw;
      text-align: center;
    }

    .tabs{
      padding: 3% 2%;
      overflow-x: scroll;
      gap: 10px;
      justify-content: flex-start;
      background-color: white;
      align-items: center;
    }

    .tabs .tab{
      width: auto;
      flex-shrink: 0;
      padding: 1% 2%;
      border: 1px solid #0F0C38;
      border-radius: 100px;
    }

    .tabs .selected{
      background-color: unset;
      box-shadow: unset;
      border: 1px solid #7d1deb;
    }

    .tabs .tab .happybox-button{
      background-color: unset;
      padding: unset;
      border: unset;
      border-radius: unset;
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 3vw;
    }

    .tabs .tab .subtitle{
      display: none;
    }

    .tabs .tab.selected .arrow.down{
      position: static;
      border: solid #7d1deb;
      border-width: 0 2px 2px 0;
    }

    .tabs .selected .happybox-button span{
      color: #7d1deb;
    }

    .selected .circle.remove{
      display: none;
    }
    .capacity-overlay{
      font-size: 3.5vw;
      text-align: center;
    }

    .custom-header{
      margin: unset
    }

    .ticker{
      height: 60px;
    }

    .tabs.sticky.hasTicker{
      padding-top: 61px;
    }

    .product-container.big{
      width: 100%;
    }

    .product-container.big .product-title{
      font-size: 3.5vw;
    }

    .purple-copy,.bundle-instructions,.tier-subcopy{
      font-size: 3.5vw;
    }
  }
  
</style>